// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container-skill {
  display: column;
  justify-content: center;
  width: 100%;
  margin-top: 20px;
  position: relative;
}

.text.title {
  font-weight: bold;
}

/* Media query for mobile */
@media (max-width: 768px) {
  .label {
    font-size: 8px;
    text-transform: uppercase;
  }
}
.container-skill-chart {
  border-radius: 10px;
  margin: 10px;
  display: flex;
  justify-content: space-between;
}

.label-skill {
  padding: 2px 10px;
  font-size: 14px;
  text-transform: uppercase;
  font-weight: bolder;
}

.align-center {
  display: flex;
  align-items: center;
  justify-content: center;
}

.icon-band {
  margin-right: 10px;
  margin-left: 5px;
  font-size: 22px;
  cursor: pointer;
}

.container-chart {
  width: 100%;
  height: 350px;
  padding: 10px;
}`, "",{"version":3,"sources":["webpack://./src/components/shared-components/components/widget-counter-skill-expandable/widget-counter-skill-expandable.component.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,uBAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;AACF;;AAEA;EACE,iBAAA;AACF;;AAEA,2BAAA;AACA;EACE;IACE,cAAA;IACA,yBAAA;EACF;AACF;AAEA;EACE,mBAAA;EACA,YAAA;EACA,aAAA;EACA,8BAAA;AAAF;;AAGA;EACE,iBAAA;EACA,eAAA;EACA,yBAAA;EACA,mBAAA;AAAF;;AAGA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;AAAF;;AAGA;EACE,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,eAAA;AAAF;;AAGA;EACE,WAAA;EACA,aAAA;EACA,aAAA;AAAF","sourcesContent":[".container-skill {\n  display: column;\n  justify-content: center;\n  width: 100%;\n  margin-top: 20px;\n  position: relative;\n}\n\n.text.title {\n  font-weight: bold;\n}\n\n/* Media query for mobile */\n@media (max-width: 768px) {\n  .label {\n    font-size: 8px;\n    text-transform: uppercase;\n  }\n}\n\n.container-skill-chart {\n  border-radius: 10px;\n  margin: 10px;\n  display: flex;\n  justify-content: space-between;\n}\n\n.label-skill {\n  padding: 2px 10px;\n  font-size: 14px;\n  text-transform: uppercase;\n  font-weight: bolder;\n}\n\n.align-center {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.icon-band {\n  margin-right: 10px;\n  margin-left: 5px;\n  font-size: 22px;\n  cursor: pointer;\n}\n\n.container-chart {\n  width: 100%;\n  height: 350px;\n  padding: 10px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
